import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { ResponsiveBar } from "@nivo/bar";
import { govPlanMetricsDatasource } from "../../../../../../shared/providers/gov-plan/metrics/datasource";

export const GovPlanMetricsChart = () => {
    const navigate = useNavigate();
    const { data } = useQuery({
        queryKey: ["gov-plan-metrics"],
        queryFn: async () => {
            const response =
                await govPlanMetricsDatasource.projectsMetricsBySecretary();
            return response.data;
        },
        initialData: { metrics: [] },
    });

    const metrics = data.metrics.map((it) => ({
        id: it.secretaryid,
        secretaria: it.secretaryname,
        projetos: it.total,
    }));

    return (
        <div className="flex flex-col w-full h-screen h-[70vh] border rounded-lg shadow-md">
            <ResponsiveBar
                data={metrics}
                keys={["projetos"]}
                indexBy="secretaria"
                margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
                padding={0.15}
                layout="horizontal"
                valueScale={{ type: "linear" }}
                indexScale={{ type: "band", round: true }}
                colors={{ scheme: "orange_red" }}
                borderColor={{
                    from: "color",
                    modifiers: [["darker", 1.6]],
                }}
                axisTop={null}
                axisRight={null}
                axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "Qtd. Projetos",
                    legendPosition: "middle",
                    legendOffset: 32,
                    truncateTickAt: 0,
                }}
                axisLeft={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "Secretaria",
                    legendPosition: "middle",
                    legendOffset: -40,
                    truncateTickAt: 0,
                }}
                labelSkipWidth={12}
                labelSkipHeight={12}
                labelTextColor={{
                    from: "color",
                    modifiers: [["darker", 1.6]],
                }}
                legends={[
                    {
                        dataFrom: "keys",
                        anchor: "bottom-right",
                        direction: "column",
                        justify: false,
                        translateX: 120,
                        translateY: 0,
                        itemsSpacing: 2,
                        itemWidth: 100,
                        itemHeight: 20,
                        itemDirection: "left-to-right",
                        itemOpacity: 0.85,
                        symbolSize: 20,
                        effects: [
                            {
                                on: "hover",
                                style: {
                                    itemOpacity: 1,
                                },
                            },
                        ],
                    },
                ]}
                role="application"
                barAriaLabel={(e) => {
                    return `${e.id}: ${e.formattedValue}`;
                }}
                onClick={(e) =>
                    navigate(`secretaria/${e.data.secretaria}|@|${e.data.id}`)
                }
            />
        </div>
    );
};
